import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { MessagesService } from '../messages.service';
import { TypesErrors } from '@app/enums/errors.enum';
import { messageNoCkn } from '@app/utils';
import { Router } from '@angular/router';
import { ErrorModel } from '@models/micro/error.model';
import { GlobalsService } from './globals.service';
import { GlobalsService as GlobalsServiceOld } from '../globals.service';

@Injectable({
  providedIn: 'root',
})
export class RequiredDocumentsService {
  constructor(
    private _apiService: ApiService,
    private _message: MessagesService,
    private _router: Router,
    private _globalService: GlobalsService,
    private _globalServiceOld: GlobalsServiceOld
  ) {}

  getViewDocuments(reservation, handleSuccess?, routeUrl = '') {
    return new Promise((resolve, reject) => {
      this._apiService.getRequireDocuments(reservation).subscribe({
        next: res => {
          if (handleSuccess) {
            handleSuccess(res);
          }
        },
        error: (error: ErrorModel) => {
          return resolve(false);
        },
        complete: () => {
          return resolve(true);
        },
      });
    });
  }
}
